@if (event) {
  <div class="linkedEvents">
    <div class="mainEvent">
      <h1 class="title" [title]="'page.detail.linked_event.main_event_title' | translate"><span [class.active]="!event.linkedToMainStreappID">{{'page.detail.linked_event.main_event_title' | translate}}</span></h1>
      <div class="mainevent-container">
        <!-- Is not selected -->
        @if (!!event.linkedToMainStreappID) {
          <a routerLink="/detail/{{event.linkedStreappEvents[0]?.partitionKey}}" class="cardLink">
            <image-block
              [hoverText]="event.linkedStreappEvents[0]?.description"
              [thumbnail]="event.linkedStreappEvents[0]?.thumbnail"
            [created]="event.linkedStreappEvents[0]?.created"></image-block>
          </a>
        }
        <!-- Is selected -->
        @if (!event.linkedToMainStreappID) {
          <image-block
            [hoverText]="event.description"
            [thumbnail]="event.thumbnail"
            [created]="event.created"
          [active]="true"></image-block>
        }
      </div>
    </div>
    <div class="subEvents">
      <h1 class="title" [title]="'page.detail.linked_event.sub_event_title' | translate"><span [class.active]="!!event.linkedToMainStreappID">{{'page.detail.linked_event.sub_event_title' | translate}}</span></h1>
      <div class="subevents-container" >
        @if (!!event.linkedToMainStreappID) {
          @for (linkedEvent of event.linkedStreappEvents[0]?.linkedStreappEvents; track linkedEvent) {
            <a routerLink="/detail/{{linkedEvent.partitionKey}}" class="cardLink">
              <image-block
                [hoverText]="linkedEvent.description"
                [thumbnail]="linkedEvent.thumbnail"
                [created]="linkedEvent.created"
              [active]="event.partitionKey === linkedEvent.partitionKey"></image-block>
            </a>
          }
        }
        @if (!event.linkedToMainStreappID) {
          @for (linkedEvent of event.linkedStreappEvents; track linkedEvent) {
            <a routerLink="/detail/{{linkedEvent.partitionKey}}" class="cardLink">
              <image-block
                [hoverText]="linkedEvent.description"
                [thumbnail]="linkedEvent.thumbnail"
                [created]="linkedEvent.created"
              [active]="event.partitionKey === linkedEvent.partitionKey"></image-block>
            </a>
          }
        }
      </div>
    </div>
  </div>
}
